/* @flow */

import React from 'react';

type Props = {
  video: BucketResource,
};

const videoStyles = {
  objectFit: 'contain',
  maxWidth: '100%',
  maxHeight: '100%',
};

const ResourceVideo = ({ video }: Props) => (
  <video controls style={videoStyles}>
    <source src={video.url.original} />
  </video>
);

export default ResourceVideo;



// WEBPACK FOOTER //
// ./src/shared/components/ResourceVideo.js